import { Component, Input, OnInit } from '@angular/core';
import { ComponenteCuentaModeloMLS, ObtenerInformacionAdicionalMS } from 'src/app/open-api';

@Component({
  selector: 'app-cuenta-informacion',
  templateUrl: './cuenta-informacion.component.html',
  styleUrls: ['./cuenta-informacion.component.scss']
})
export class CuentaInformacionComponent implements OnInit {

  @Input() set Informacion(informacion: ObtenerInformacionAdicionalMS) {
    this.informacion = informacion;
    this.ObtenerComplementos();
  };
  informacion?: ObtenerInformacionAdicionalMS;
  componentes: ComponenteCuentaModeloMLS[] = [];
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;

  constructor() { }

  ngOnInit(): void {
  }

  ObtenerComplementos() {
    this.componentes = (this.informacion?.componentesCuenta || [])
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
    this.cantidad = (this.informacion?.componentesCuenta?.length || 0);
  }

}
